/**
 * 홈(휴대폰) 「카메라로 찍어서 찾기」 → 사진 검색으로 사진을 넘기는 작은 저장소 (컨셉 §7.6).
 *
 * 브라우저는 파일 선택 창을 「사용자가 누른 그 순간」에만 열어 준다(iOS Safari 는 특히 엄격).
 * 사진 검색 화면이 그려진 뒤에 input.click() 을 부르면 막히므로, 카메라 입력은 앱 틀(Shell)에
 * 늘 붙어 있고 버튼이 그 자리에서 연다. 찍은 사진은 여기 맡겨 두고 사진 검색 화면이 꺼내 간다.
 */
let pending: File | null = null;
const subs = new Set<(f: File) => void>();
let opener: (() => void) | null = null;

/** Shell 의 숨은 카메라 입력이 자신을 등록한다 */
export function registerCameraOpener(fn: (() => void) | null): void {
  opener = fn;
}

/** 버튼의 클릭 처리 안에서 바로 부른다 — 기본 카메라 앱이 열린다 */
export function openCamera(): boolean {
  if (!opener) return false;
  opener();
  return true;
}

/** 숨은 입력이 받은 사진을 맡긴다. 사진 검색 화면이 이미 떠 있으면 바로 건넨다. */
export function deliverCapture(f: File): void {
  if (subs.size) { subs.forEach((fn) => fn(f)); pending = null; }
  else pending = f;
}

/** 사진 검색 화면 — 맡겨 둔 사진을 꺼내고, 이후 도착하는 사진도 받는다 */
export function subscribeCapture(fn: (f: File) => void): () => void {
  if (pending) { const f = pending; pending = null; fn(f); }
  subs.add(fn);
  return () => { subs.delete(fn); };
}
